import { Controller } from "@hotwired/stimulus"

// Manages funerary plan form visibility - shows/hides fields based on product type.
// Hidden inputs are also `disabled` so they don't submit — some fields (e.g.
// grace_period_in_days) are rendered twice in the form, once for cemetery and
// once for funerary. Without disabling, the hidden copy submits an empty value
// that overwrites the user-entered one.
export default class extends Controller {
  static targets = ["funerarySection", "cemeteryField", "pricingModel", "duesField"]

  connect() {
    this.toggleFuneraryFields()
    this.togglePricingModel()
  }

  // Plano só-adesão não cobra mensalidade: mensalidade, beneficiário e agregado
  // saem do cadastro para ninguém preencher campo que o cálculo ignora.
  togglePricingModel() {
    if (!this.hasPricingModelTarget) return

    const adhesionOnly = this.pricingModelTarget.value === "adhesion_only"
    this.duesFieldTargets.forEach((field) => field.classList.toggle("hidden", adhesionOnly))
  }

  toggleFuneraryFields() {
    const productTypeSelect = this.element.querySelector("select[name='product[product_type]']")
    const isFuneraryPlan = productTypeSelect?.value === "funerary_plan"

    if (this.hasFunerarySectionTarget) {
      this.#setHidden(this.funerarySectionTarget, !isFuneraryPlan)
    }

    this.cemeteryFieldTargets.forEach(field => this.#setHidden(field, isFuneraryPlan))

    this.element.querySelectorAll(".cemetery-only-field").forEach(field => {
      this.#setHidden(field, isFuneraryPlan)
    })
  }

  #setHidden(container, hidden) {
    container.classList.toggle("hidden", hidden)
    container.querySelectorAll("input, select, textarea").forEach(input => {
      input.disabled = hidden
    })
  }
}
